import React from "react";

interface Props {
  mode?: string;
  courseName?: string;
}

const FinalCta: React.FC<Props> = ({ mode, courseName }) => {
  const isUpcoming = mode === "upcoming";

  return (
    <section className="final-cta" aria-labelledby="final-cta-title">
      <div className="blob" aria-hidden="true">
        <svg
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid slice"
          xmlns="http://www.w3.org/2000/svg"
        >
          <svg x="-5%" y="20%" overflow="visible">
            <use
              href="#blob-1"
              fill="#F3EC7A"
              transform="scale(1.68)"
              opacity="0.18"
            />
          </svg>

          <svg x="80%" y="60%" overflow="visible">
            <use
              href="#blob-2"
              fill="#B798F2"
              transform="scale(1.68)"
              opacity="0.18"
            />
          </svg>
        </svg>
      </div>

      <div className="container">
        {isUpcoming ? (
          <h2 id="final-cta-title">
            Want to hear when{" "}
            <span className="nobr">
              <em className="hl">{courseName}</em>
            </span>{" "}
            opens?
          </h2>
        ) : (
          <h2 id="final-cta-title">
            You can keep reading reviews. Or you can{" "}
            <span className="nobr">
              <em className="hl">start the course</em>.
            </span>
          </h2>
        )}

        <p>
          {isUpcoming
            ? "Join the launch list and we'll let you know the moment it is ready."
            : "The reviews aren't going anywhere. Neither is your to-do list. One of them gets shorter when you click below."}
        </p>

        <div className="ctas">
          {isUpcoming ? (
            <a
              href="#launch-signup"
              className="btn btn-blue"
              style={{
                background: "var(--blue)",
                borderColor: "var(--sunshine)",
                color: "var(--white)",
              }}
            >
              Be first to know
            </a>
          ) : (
            <a
              href="#"
              data-smooth-scroll-to="#pricing-container"
              className="btn btn-blue"
              style={{
                background: "var(--blue)",
                borderColor: "var(--sunshine)",
                color: "var(--white)",
              }}
            >
              See pricing
            </a>
          )}

          {!isUpcoming && (
            <a href="/passes/month/pay" className="btn btn-white">
              Get All Access
            </a>
          )}
        </div>

        <div className="reassure">
          <svg aria-hidden="true">
            <use href="#ic-shield" />
          </svg>{" "}
          {isUpcoming
            ? "No spam. Just the launch note."
            : "30-day money back. No questions, no exit interview."}
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
